import axios from "axios";
import type { Store } from "@reduxjs/toolkit";

import { userLoggedOut } from "@/store/slices/authSlice";
import { toast } from "@/hooks/useToast";
import type { RootState } from "@/types/store";

export const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

let store: Store<RootState> | null = null;

export const setStore = (storeInstance: Store<RootState>) => {
  store = storeInstance;
};

apiClient.interceptors.request.use(
  (config) => {
    if (store) {
      const token = store.getState().Auth.token;

      if (token) {
        config.headers[`Authorization`] = token;
      }
    }

    // Add X-ORIGIN-SLUG header to every request
    // Use env variable for local dev, otherwise extract from subdomain
    const hostname = window.location.hostname;
    const slug =
      import.meta.env.VITE_ORIGIN_SLUG || hostname.split(".")[0];
    config.headers["X-ORIGIN-SLUG"] = slug;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && store) {
      store.dispatch(userLoggedOut());
      toast({
        title: "Error",
        description: "Your access token has been invalidated",
        variant: "destructive",
        priority: 1,
      });
    }
    return Promise.reject(error);
  }
);
